module.exports = __webpack_public_path__ + "static/media/whatsapp.614b4841.svg";